var m = Object.defineProperty;
var p = (n, e, i) => e in n ? m(n, e, { enumerable: !0, configurable: !0, writable: !0, value: i }) : n[e] = i;
var s = (n, e, i) => p(n, typeof e != "symbol" ? e + "" : e, i);
import { ALIGN_CLASSES_INVERSE as c, MENTION_CLASS as u, NO_MARGIN_CLASS as f } from "./constants.js";
import { decodeAttributes as g } from "./utils/attribute-encoding.js";
import { BlockListParser as k, DocumentHtmlEntityDecoder as M } from "@intercom/interblocks.ts";
class v {
  constructor(e, i) {
    s(this, "blockAttrs");
    s(this, "markMap");
    s(this, "nodeMap");
    s(this, "marks", ["b", "i", "a", "code", "u", "span"]);
    s(this, "nodes", ["p", "br", "ol", "ul", "li", "h1", "h2", "h3", "h4", "small", "pre", "img"]);
    this.documentBuilder = e, this.config = i;
    let t = e.schema;
    this.markMap = {
      b: t.marks.bold,
      i: t.marks.italic,
      a: t.marks.anchor,
      code: t.marks.code,
      u: t.marks.underline,
      span: t.marks.span
    }, this.nodeMap = {
      p: t.nodes.paragraph,
      ol: t.nodes.orderedList,
      ul: t.nodes.unorderedList,
      li: t.nodes.listItem,
      h1: t.nodes.heading,
      h2: t.nodes.subheading,
      h3: t.nodes.subheading3,
      h4: t.nodes.subheading4,
      small: t.nodes.small,
      pre: t.nodes.codeBlock,
      br: t.nodes.hardBreak,
      hr: t.nodes.horizontalLine,
      template: t.nodes.template,
      mention: t.nodes.mention,
      aiPromptData: t.nodes.aiPromptData,
      img: t.nodes.inlineImage
    };
  }
  handle(e, i) {
    k.parse(
      [e],
      new M(document),
      !!this.nodeMap.template,
      this.config.isPlaintext,
      !0,
      !1,
      !1
    ).body.forEach((a) => this.handleNode(a, i));
  }
  handleNode(e, i) {
    if (e.isElement)
      if (this.isMention(e))
        this.mention(e);
      else if (this.isAiPromptData(e))
        this.aiPromptData(e);
      else if (this.marks.includes(e.value))
        this.mark(e);
      else if (this.nodes.includes(e.value))
        this.node(e, i);
      else
        throw new Error(`unknown element type: ${e.value}`);
    else e.isLiteral ? this.documentBuilder.addText(e.value) : e.type === "Template" ? this.template(e) : (this.stashBlockAttrs(e), this.handleChildren(e.children, i));
  }
  node(e, i) {
    let t = this.nodeMap[e.value];
    if (!t)
      return;
    let a = this.collectAttrs(e), l = this.consumeBlockAttrs();
    if (this.addAlignment(a, l), this.addStyle(a), t === this.nodeMap.img) {
      let o = e.attributes.find((r) => r.name === "alt");
      o && (a.text = o.value);
      let h = e.attributes.find((r) => r.name === "data-class-name");
      h && (a.className = h.value);
    }
    if (this.documentBuilder.openNode(t, a), t === this.nodeMap.li) {
      let o = this.nodeMap.p;
      this.documentBuilder.openNode(o, {});
    }
    this.handleChildren(e.children, i), t === this.nodeMap.li && this.documentBuilder.closeNode(), this.documentBuilder.closeNode(), this.addExtraParagraphIfLegacyParagraph(e, l, i);
  }
  mark(e) {
    let i = this.markMap[e.value], t;
    i && this.documentBuilder.top().type.allowsMarkType(i) && (t = i.create(this.collectAttrs(e)), this.documentBuilder.openMark(t), i === this.markMap.a && this.handleInlineImageLinkUrl(t, e)), this.handleChildren(e.children), t && this.documentBuilder.closeMark(t);
  }
  mention(e) {
    let i = this.collectAttrs(e);
    this.nodeMap.mention && (this.documentBuilder.openNode(this.nodeMap.mention, {
      name: e.children[0].value,
      uri: i.href
    }), this.documentBuilder.closeNode());
  }
  aiPromptData(e) {
    let i = this.collectAttrs(e), t = {};
    for (let [a, l] of Object.entries(i))
      if (a.startsWith("data-prompt-data-")) {
        let h = a.split("-").slice(3).map((r, d) => d === 0 ? r : r.charAt(0).toUpperCase() + r.slice(1)).join("");
        t[h] = l;
      }
    i = t, this.nodeMap.aiPromptData && (this.documentBuilder.openNode(this.nodeMap.aiPromptData, i), this.documentBuilder.closeNode());
  }
  template(e) {
    this.nodeMap.template && (this.documentBuilder.openNode(this.nodeMap.template, {
      attributePath: e.value,
      fallback: e.fallback
    }), this.documentBuilder.closeNode());
  }
  handleInlineImageLinkUrl(e, i) {
    if (i.children.length === 1 && i.children[0].value === "img") {
      let t = e.attrs.href;
      i.children[0].attributes.push({
        type: "Attribute",
        name: "linkUrl",
        value: t
      });
    }
  }
  collectAttrs(e) {
    let i = {};
    return e.attributes.forEach((t) => {
      let a = g(t.value);
      i[t.name] ? i[t.name] += ` ${a}` : i[t.name] = a;
    }), e.type === "Block" && (i.type = e.value), e.isElement && e.id && (i.idAttribute = e.id), i;
  }
  stashBlockAttrs(e) {
    this.blockAttrs = this.collectAttrs(e);
  }
  consumeBlockAttrs() {
    let e = this.blockAttrs;
    return this.blockAttrs = void 0, e;
  }
  addAlignment(e, i) {
    !i || typeof i.class != "string" || i.class.split(" ").forEach((t) => {
      let a = c[t];
      a && Object.assign(e, { alignment: a });
    });
  }
  addStyle(e) {
    !e || typeof e.style != "string" || e.style.split(";").forEach((i) => {
      if (!i)
        return;
      let t = i.split(":", 2), a = t[0], l = t[1].trim();
      a === "font-family" && Object.assign(e, { fontFamily: l }), a === "color" && Object.assign(e, { fontColor: l }), a === "width" && Object.assign(e, { width: l.replace("px", "") });
    });
  }
  handleChildren(e, i) {
    e.forEach((t) => {
      this.handleNode(t, i);
    });
  }
  isMention(e) {
    return this.nodeMap.mention && e.value === "a" && e.attributes.find((i) => i.name === "class" && i.value === u);
  }
  isAiPromptData(e) {
    return this.nodeMap.aiPromptData && e.value === "span" && e.attributes.find((i) => i.name === "data-ai-prompt-data");
  }
  addExtraParagraphIfLegacyParagraph(e, i, t) {
    this.isParagraphWithImplicitMargin(e, i, t) && !this.config.singleBlockMode && !this.config.allowImplicitMarginParagraphs && (this.documentBuilder.openNode(this.nodeMap.p, {}), this.documentBuilder.closeNode());
  }
  isParagraphWithImplicitMargin(e, i, t) {
    return !i || !t ? !1 : e.value === "p" && !i.class.includes(f);
  }
}
export {
  v as TextBlockParser
};
